(function() {
	'use strict';

	angular.module('showcaseApp').service('BankDataService', BankDataService);

	BankDataService.$inject = [ 'BankDataFactory' ];

	function BankDataService(BankDataFactory) {
		var service = {
			getBanks : getBanks,
			findBanks : findBanks
		};

		return service;

		function getBanks() {
			var banks = BankDataFactory.getBanks().$promise;
			return banks;
		}

		function findBanks(search, page, size) {
			return BankDataFactory.findBanks({ search: search, page: page, size: size }).$promise;
		}

	}
})();
